import { TransactionStatusConvertor } from "@/models/payload/transaction";
import { TransactionDto } from "@/models/response/trnsactions";
import { Group, Paper, Stack, Text } from "@mantine/core";
import moment from "moment-jalaali";
import { IconArrowDown, IconArrowUp } from "@tabler/icons-react";

type Props = {
  transaction: TransactionDto;
};

function TransactionItem({ transaction }: Props) {
  return (
    <Stack>
      <Paper withBorder p="md">
        <Stack>
          <Group justify="space-between">
            <Group gap="3">
              <Text size="xs">
                {transaction.transactionType === 1 ? (
                  <IconArrowUp color="green" size={"1rem"} />
                ) : (
                  <IconArrowDown color="red" size={"1rem"} />
                )}
              </Text>
              <Text size="xs">
                {moment(transaction?.creationTime).format(
                  "jYYYY/jMM/jDD - HH:mm"
                )}
              </Text>
            </Group>

            {
              TransactionStatusConvertor[
                transaction?.status as keyof typeof TransactionStatusConvertor
              ]
            }
          </Group>
          <Group justify="space-between">
            <Text size="xs">مبلغ : </Text>
            <Group gap="5">
              <Text size="xs" fw="900">
                {transaction?.amount?.toLocaleString()}
              </Text>
              <Text size="xs">ریال</Text>
            </Group>
          </Group>
          <Text size="xs" c="dimmed">
            {transaction?.description}
          </Text>
        </Stack>
      </Paper>
    </Stack>
  );
}

export default TransactionItem;
